/**
 * @module acng/regard/factory/regard
 */

import {user} from '../../user/user.js';
import {media} from 'acng/core/service/env';
import {inject} from 'acng/core/service/ng';
import {recentMessageIsIcebreaker} from 'acng/messenger/service/recent-message.js';
import {publishUserMessage} from 'acng/messenger/service/event-bus.js';
import {Message} from 'acng/messenger/model/message.js';
import {popup} from '@acng/frontend-discovery';
import {fsk} from 'acng/userPool/fsk.js';
import {getFallbackImageUrl} from 'acng/layout/service/fallback-image';
import {Auth} from '../../user/auth/auth.js';

type FskTrans = import('acng/userPool/0fsk').FskTrans;

export type RegardData = {
  id: number;
  price: number;
  icon: string;
  fsk: number;
  name: Exclude<FskTrans, null>;
  description: Exclude<FskTrans, null>;
};

type RegardSendData = {
  recipient: string;
  regard: number;
  message: string;
  icebreakerAnswer: boolean;
  livecamTip?: boolean;
};

export class Regard {
  static recipient: Amateur | null = null;

  id: number;
  price: number;
  icon: string;
  icon_fallback_url: string;
  fsk: number;
  name: Exclude<FskTrans, null>;
  description: Exclude<FskTrans, null>;
  livecamTip = false;

  constructor(data: RegardData) {
    this.name = data.name;
    this.icon = data.icon;
    this.id = data.id;
    this.description = data.description;
    this.price = data.price;
    this.fsk = data.fsk;
    this.icon_fallback_url = getFallbackImageUrl('300');
  }

  getIconUrl() {
    return this.fsk > fsk.get() ? this.icon_fallback_url : `${media.content.items}${this.icon}`;
  }

  async send(text: string) {
    if (!Regard.recipient) {
      throw Error('something went wrong');
    }
    const http = inject('http');

    try {
      // TODO
      await http().post(
        'api/regard/send',
        {
          recipient: Regard.recipient.id,
          regard: this.id,
          message: text,
          livecamTip: this.livecamTip,
          icebreakerAnswer: await recentMessageIsIcebreaker(Regard.recipient),
        } as RegardSendData,
        {
          headers: {'Content-Type': 'application/json'},
          dontIntercept: true,
        }
      );
      publishUserMessage(new Message(Regard.recipient, {
        sender: {
          product_id: user.pool_id,
          id: `${user.id}`,
        },
        body: text,
        timestamp_ms: Date.now(),
        attachment: null,
        payload: {
          type: 'regard',
          image: this.icon,
          text: text,
        },
      }));
    } catch (err: any) {
      const payment = inject('payment');
      switch (err.status) {
        case 401:
          user.guestSignup('regard.signupRequired', {nickname: Regard.recipient.getNickname()}) || (new Auth()).kick();
          throw null;
        case 402:
          if (err.data.code === 4001) {
            throw err;
          }
          payment.overlay('regard.paymentRequired', {nickname: Regard.recipient.getNickname()});
          throw null;
        case 409:
          popup().error(err.data.message);
          throw null;
      }
      throw err;
    }
  }

  async sendTo(amateur: Amateur, overlay?: import('acng/core/service/overlay').Overlay) {
    const fskTransFilter = inject('fskTransFilter');
    Regard.recipient = amateur;
    const res = await this.send(fskTransFilter(this.description));
    overlay?.close();
    return res;
  }
}
